(() => {
  const bar = document.querySelector('.product__sticky-atc');
  if (!bar) return;

  const root = document.documentElement;

  const updateOffset = () => {
    const visible = bar.classList.contains('is-visible') && !bar.hidden;
    root.style.setProperty('--sticky-atc-offset', visible ? `${bar.offsetHeight}px` : '0px');
  };

  new ResizeObserver(updateOffset).observe(bar);
  new MutationObserver(updateOffset).observe(bar, { attributes: true, attributeFilter: ['class', 'hidden'] });
  updateOffset();
})();
